import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* getLocationList() {
  yield takeEvery(actionTypes.GET_LOCATION, function*(action) {
    try {
      const response = yield API.getLocation();
      if (response.data.success) {
        yield put(actions.getLocationListSuccess(response.data));
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      // alert(API.constructErrMsg(error));
      yield put(actions.handleAPIError(error, "Fail to load location. \n"))
    }
  });
}

export function* submitLocation() {
  yield takeEvery(actionTypes.STORE_LOCATION, function*(action) {
    yield put(actions.submitLocationSuccess(action.data));
  });
}

export default function* locationSaga() {
  yield all([
    fork(getLocationList),
    fork(submitLocation)
  ]);
}
